import React, { useState } from 'react';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from "../Database";
import { useLoaderContext } from '../contexts/loader';
import { usePopUpContext } from '../contexts/Popup';
import { useUserContext } from '../contexts/user';
import { useNavigate } from 'react-router-dom';
import { Languages } from 'lucide-react';

const AuthPage = () => {
    const navigate = useNavigate();
    const [isSignUp, setIsSignUp] = useState(false);
    const [activeUser, setActiveUser] = useState("student");
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
        student_id: '',
    });

    const { setIsLoading } = useLoaderContext();
    const { setMessageContent } = usePopUpContext();
    const { setUser, setUserInfo, setUserJWT, appLanguage, setAppLanguage, setUserIndex, setSuperVisorStudent } = useUserContext();

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const toggleLanguage = () => {
        const newLang = appLanguage === "ar" ? "en" : "ar";
        setAppLanguage(newLang);
        localStorage.setItem("appLanguage", newLang);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isSignUp) {
            setIsLoading(prev => prev + 1);
            createUserWithEmailAndPassword(auth, formData.email, formData.password).then(() => {
                fetch("https://quiz-battle-api.vercel.app/api/sign-up", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        email: formData.email,
                        password: formData.password,
                        role: activeUser,
                        public_id: formData.student_id,
                        username: formData.username,
                    }),
                }).then(res => res.json())
                    .then(data => {
                        if (data.failed) {
                            setIsLoading(prev => prev !== 0 ? prev - 1 : prev);
                            setMessageContent({ title: appLanguage === "ar" ? "خطأ فى إنشاء الحساب" : "Signing up error", message: appLanguage === "ar" ? "حدث خطأ أثناء إنشاء الحساب" : "Oops! something went wrong while creating your account.", })
                        } else {
                            setIsLoading(prev => prev !== 0 ? prev - 1 : prev);
                            localStorage.setItem("user", data.id || data.userData.id);
                            setUser(data.id || data.userData.id);
                            setUserIndex(1);
                            setUserInfo(data || data.userData);
                            setUserJWT(data.JWT);
                            localStorage.setItem("user token", data.JWT);
                            navigate("/home");
                        }
                    }).catch(err => {
                        setIsLoading(prev => prev !== 0 ? prev - 1 : prev);
                        setMessageContent({ title: appLanguage === "ar" ? "خطأ فى إنشاء الحساب" : "Signing up error", message: appLanguage === "ar" ? "حدث خطأ أثناء إنشاء الحساب" : "Oops! something went wrong while creating your account.", });
                    })

            }).catch(err => {
                setIsLoading(prev => prev !== 0 ? prev - 1 : prev);
                setMessageContent({ title: appLanguage === "ar" ? "خطأ فى إنشاء الحساب" : "Signing up error", message: appLanguage === "ar" ? "حدث خطأ أثناء إنشاء الحساب" : "Oops! something went wrong while creating your account.", });
            })
        } else {
            setIsLoading(prev => prev + 1);
            signInWithEmailAndPassword(auth, formData.email, formData.password)
                .then(() => {
                    fetch("https://quiz-battle-api.vercel.app/api/get-sign-in-data", {
                        method: "POST",
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            email: formData.email,
                            password: formData.password,
                        }),
                    }).then(res => res.json())
                        .then(data => {
                            if (data.failed) {
                                setMessageContent({ title: appLanguage === "ar" ? "خطأ فى تسجيل الدخول" : "Signing in error", message: appLanguage === "ar" ? "حدث خطأ أثناء تسجيل الدخول." : "Oops! something went wrong while signing you in.", });
                                setIsLoading(prev => prev !== 0 ? prev-- : 0);
                            } else {
                                setUser(data.userData.id);
                                setUserInfo(data.userData);
                                setUserIndex(1);
                                localStorage.setItem("user", data.userData.id);
                                setUserJWT(data.userData.JWT || data.JWT);
                                localStorage.setItem("user token", (data.userData.JWT || data.JWT));
                                navigate("/home");
                                if (data.userData.role === "supervisor") {
                                    setSuperVisorStudent(data.userData.superVisorData);
                                }
                                setIsLoading(prev => prev !== 0 ? prev - 1 : prev);
                            }
                        }).catch(err => {
                            setIsLoading(prev => prev !== 0 ? prev - 1 : prev);
                            setMessageContent({ title: appLanguage === "ar" ? "خطأ فى تسجيل الدخول" : "Signing in error", message: appLanguage === "ar" ? "حدث خطأ أثناء تسجيل الدخول." : "Oops! something went wrong while signing you in.", });
                        })
                }).catch(err => {
                    setMessageContent({ title: appLanguage === "ar" ? "خطأ فى تسجيل الدخول" : "Signing in error", message: appLanguage === "ar" ? "حدث خطأ أثناء تسجيل الدخول." : "Oops! something went wrong while signing you in.", });
                    setIsLoading(prev => prev !== 0 ? prev - 1 : prev);
                })
        }
    };

    const toggleMode = () => {
        setIsSignUp(!isSignUp);
        setFormData({
            username: '',
            email: '',
            password: ''
        });
    };

    return (
        <div className="auth-container">
            <button className="language-toggle-btn" onClick={toggleLanguage} title={appLanguage === "ar" ? "Switch to English" : "التبديل للعربية"}>
                <Languages size={24} />
            </button>
            <div className="auth-box">
                <div className="header">
                    <h1 className="logo">Quiz Battle</h1>
                    <p className="subtitle">{appLanguage === "ar" ? "حل إختبارات من مدرسيك" : "Solve quizzes from your teachers"}</p>
                </div>

                <div className="tab-container">
                    <button
                        className={`tab ${!isSignUp ? 'active' : ''}`}
                        onClick={() => !isSignUp || toggleMode()}
                    >
                        {appLanguage === "ar" ? "تسجيل الدخول" : "Sign In"}
                    </button>
                    <button
                        className={`tab ${isSignUp ? 'active' : ''}`}
                        onClick={() => isSignUp || toggleMode()}
                    >
                        {appLanguage === "ar" ? "إنشاء حساب" : "Sign Up"}
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="form">
                    {isSignUp && (
                        <div className="input-group">
                            <label className="label">{appLanguage === "ar" ? "إسم المستخدم" : "Username"}</label>
                            <input
                                type="text"
                                name="username"
                                value={formData.username}
                                onChange={handleInputChange}
                                className="input"
                                placeholder={appLanguage === "ar" ? "أدخل إسم المستخدم" : "Enter your username"}
                                required
                            />
                        </div>
                    )}

                    <div className="input-group">
                        <label className="label">{appLanguage === "ar" ? "البريد الإلكترونى" : "Email"}</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            className="input"
                            placeholder={appLanguage === "ar" ? "أدخل البريد الإلكترونى" : "Enter your email"}
                            required
                        />
                    </div>

                    <div className="input-group">
                        <label className="label">{appLanguage === "ar" ? "كلمة المرور" : "Password"}</label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            className="input"
                            placeholder={appLanguage === "ar" ? "أدخل كلمة المرور" : "Enter your password"}
                            required
                        />
                    </div>

                    {activeUser === "supervisor" && isSignUp ?
                        <div className="input-group">
                            <label className="label">{appLanguage === "ar" ? "هوية الطالب (ID)" : "Student ID"}</label>
                            <input
                                type="text"
                                name="student_id"
                                value={formData.student_id}
                                onChange={handleInputChange}
                                className="input"
                                placeholder={appLanguage === "ar" ? "أدخل هوية الطالب (ID)" : "Enter student ID"}
                                required
                            />
                        </div> : undefined}
                    {
                        isSignUp ?
                            <div className="buttons">
                                <button type="button" onClick={() => setActiveUser("student")} className={activeUser === "student" ? "active" : ""}>{appLanguage === "ar" ? "طالب" : "Student"}</button>
                                <button type="button" onClick={() => setActiveUser("teacher")} className={activeUser === "teacher" ? "active" : ""}>{appLanguage === "ar" ? "مدرس" : "Teacher"}</button>
                                <button type="button" onClick={() => setActiveUser("supervisor")} className={activeUser === "supervisor" ? "active" : ""}>{appLanguage === "ar" ? "مشرف" : "Supervisor"}</button>
                            </div> : undefined
                    }

                    <button type="submit" className="submit-button">
                        {isSignUp ? (appLanguage === "ar" ? "أنشئ حساب" : 'Create Account') : (appLanguage === "ar" ? "تسجيل الدخول" : "Sign In")}
                    </button>
                </form>

                <div className="footer">
                    <p className="footer-text" dir={appLanguage === "ar" ? "rtl" : "ltr"}>
                        {isSignUp ? (appLanguage === "ar" ? "هل تملك حساب بالفعل؟" : 'Already have an account?') : (appLanguage === "ar" ? "هل لا تملك حساب؟" : "Don't have an account?")}{' '}
                        <button onClick={toggleMode} className="link-button">
                            {isSignUp ? (appLanguage === "ar" ? "سجل الدخول" : 'Sign In') : (appLanguage === "ar" ? "أنشئ حساب" : 'Sign Up')}
                        </button>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AuthPage;